import React from 'react';

const LoadingSpinner = ({ message = "Loading..." }) => (
  <div className="text-center p-6">
    <div className="w-10 h-10 border-4 border-gray-200 border-t-blue-500 rounded-full animate-spin mx-auto mb-4"></div>
    <p className="text-gray-600 text-sm">{message}</p>
  </div>
);

export default LoadingSpinner;